module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [(!_vm.newsCookie && _vm.isMentoring) ? _c('NewsCard', {
    on: {
      "click": _vm.newsClick
    }
  }) : _vm._e(), (_vm.isRemoteEdu) ? _c('RemoteEduMenu') : _vm._e(), (_vm.children.length) ? [(_vm.isIntalentModule) ? _c('Smart', {
    attrs: {
      "id": _vm.id,
      "age": _vm.age,
      "municipalityId": _vm.municipalityId,
      "name": _vm.name,
      "initTestResult": _vm.testResult
    }
  }) : _c('Block', {
    attrs: {
      "title": "Для вас",
      "description": "Программы подбираются автоматически для обучающегося, который выбран в панели справа",
      "method": "getPrograms",
      "service": "cabinet",
      "id": _vm.id,
      "data": _vm.id,
      "isOpened": true
    }
  })] : _c('Warning', [_c('p', [_vm._v("В данный момент раздел не работает, пожалуйста, возвращайтесь позже!")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23cfb990","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/cabinet/Cabinet.vue
// module id = 696c77415f388fb8b888
// module chunks = 19